

































































































































































import { Component, Vue } from "vue-property-decorator";
import { mapActions } from "vuex";

@Component({
	methods: {
		...mapActions("project", ["addNewProject"])
	}
})
export default class UserQuestionsPost extends Vue {
	title = "";
	version = "";
	summary = "";
	license = "";
	developmentmodel = "";
	githubrepolink = "";
	website = "";
	tools = "";
	createchatgroup = false;
	chatgroupname = "";
	tags = "";
	loading = false;

	addNewProject!: any;

	license_items = ["ET", "AXU", "EAXL", "MIT"];

	developmentmodel_items = [
		"Waterfall",
		"V-Modle",
		"Incremental Model",
		"Rad(Rapid Application Development) Model",
		"Rational Unified Process",
		"Agile Model",
		"Iterative Model",
		"Spartial Model",
		"Prototype Model",
		"LEAN Model",
		"Feature Driven Development",
		"SCRUM",
		"System Analyst"
	];

	clear() {
		this.title = "";
		this.version = "";
		this.summary = "";
		this.license = "";
		this.developmentmodel = "";
		this.githubrepolink = "";
		this.website = "";
		this.tools = "";
		this.createchatgroup = false;
		this.chatgroupname = "";
		this.tags = "";
		this.loading = false;
		(this.$refs.newProjectObserver as Vue & {
			reset: () => boolean;
		}).reset();
	}

	submit() {
		this.loading = true;
		(this.$refs.newProjectObserver as Vue & {
			validate: () => any;
		})
			.validate()
			.then((isValid: boolean) => {
				if (isValid) {
					const info: any = {
						title: this.title,
						version: this.version,
						summary: this.summary,
						licence: this.license,
						developmentmodel: this.developmentmodel,
						githubrepolink: this.githubrepolink,
						website: this.website,
						tools: this.tools,
						createchatgroup: this.createchatgroup,
						chatgroupname: this.chatgroupname
					};
					console.log("ok the input is valid now lets dispatch it", info);
					this.addNewProject(info)
						.then((res: any) => {
							console.log(res);
							this.loading = false;
							this.$router.push({ name: "Project" });
						})
						.catch((err: any) => {
							setTimeout(() => (this.loading = false), 2000);
							console.log(err);
						});
				} else {
					setTimeout(() => (this.loading = false), 2000);
				}
			})
			.catch((error: any) => {
				setTimeout(() => (this.loading = false), 2000);
				console.log(error);
			});
	}
}
